// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__w_0li","choiceBoxes":"toolbarselects_choiceBoxes__1Wkja","simpleField":"toolbarselects_simpleField__15qW-"};